import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Client, DeviceConnectionDataOut, PermissionsEnum } from '../../../../api/api-reference';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AuthService } from '../../../../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device-connection-details',
  standalone: true,
  imports: [CommonModule, TranslateModule, AngularSvgIconModule],
  templateUrl: './device-connection-details.component.html',
  styleUrl: './device-connection-details.component.scss',
})
export class DeviceConnectionDetailsComponent {
  @Input() id: string | undefined;
  @Output() closeSignal = new EventEmitter<boolean>();
  public PermissionsEnum = PermissionsEnum;
  devieConnection: DeviceConnectionDataOut= new DeviceConnectionDataOut();

  constructor(
      private toastr: ToastrService,
      private client: Client,
      public authService: AuthService,
    ) {}

    toggleModal() {
      this.closeSignal.emit();
    }
  
    ngOnInit(): void {
      this.getDeviceConnectionTimeById();
    }
  
    getDeviceConnectionTimeById() {
      this.client.getDeviceConnection(this.id!).subscribe({
        next:(result)=>{
          this.devieConnection=result;
        },
        error:(err)=>{
          this.toastr.error(err);
        }
      })
    }
}





